export default __webpack_public_path__ + "static/media/LO02.b890edf6.mp3";